var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBergdorfGoodmanCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#d3d3d3",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 19,
    rx: 1.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.434 15.441c1.711 0 2.522-1.147 2.522-3.035 0-1.129-.511-2.487-2.116-2.487-.353 0-.723.035-.723-.194 0-.106.106-.141.547-.176C11.846 9.481 12.6 8.12 12.6 6.956a2.081 2.081 0 00-2.236-2.275c-.706 0-.935.071-.935.212v10.354c0 .159.265.194 1.005.194zm-.406.493c-.353 0-1.429-.018-1.57 0-.3 0-.459-.071-.459-.23V4.434c0-.194.371-.212.635-.212.477 0 1.252-.018 2.258.053a3 3 0 012.965 2.716 2.9 2.9 0 01-2.029 2.663c1.535.371 2.681 1.358 2.681 2.84 0 2.982-2.8 3.44-4.481 3.44M20.99 4.505c-2.96 0-4.241 2.328-4.241 5.359 0 3.807 2.22 5.576 3.735 5.576.541 0 .685-.09.685-.306V9.9c0-.181-.144-.235-.144-.325 0-.036.036-.072.181-.072h1.118c.271 0 .433.091.452.343v5.647c0 .307 0 .433-.163.451-.306.036-.848.055-1.082.055-4.584 0-6.568-3.14-6.568-6.117a5.872 5.872 0 015.864-5.883c1.48 0 1.931.343 1.931.577 0 .144-.216.271-.414.271-.453.001-.723-.342-1.354-.342z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBergdorfGoodmanCard);
export default __webpack_public_path__ + "static/media/BergdorfGoodmanCard.447441e5365fc68ed7db1f700a16b730.svg";
export { ForwardRef as ReactComponent };